<ngx-spinner template="<img src='assets/images/spinner.gif'/>"></ngx-spinner>
<div dir="{{languageDir}}">
    <div class="order-processing-content">
        <div class="content-top-box ">
            <app-bread-crumb></app-bread-crumb>
            <div class="top-box-content">
                <h1 class="main-title">{{langObj ? langObj?.SafetyTrends : ('SafetyTrends' | translate)}}</h1>
            </div>
        </div>

        <form [formGroup]="safetyTrendsForm">
            <div class="content-top-row content-top-row-order-processing">
                <div class="inputField">
                    <nz-date-picker class="calender-input" id="startPicker" formControlName="startDate"
                        nzFormat="dd/MM/yyyy HH:mm" [nzShowTime]="{ nzFormat: 'HH:mm' }" [nzInputReadOnly]="true">
                    </nz-date-picker>
                    <span class="floating-text">{{langObj ? langObj?.StartDate : ('StartDate' | translate)}}</span>
                </div>
                <div class="inputField">
                    <nz-date-picker class="calender-input" id="endPicker" formControlName="endDate"
                        nzFormat="dd/MM/yyyy HH:mm" [nzShowTime]="{ nzFormat: 'HH:mm' }" [nzInputReadOnly]="true">
                    </nz-date-picker>
                    <span class="floating-text">{{langObj ? langObj?.EndDate : ('EndDate' | translate)}}</span>
                </div>
                <div class="btn-position btn-position-order-processing">
                    <button mat-mini-fab color="accent" class="fab-button" matTooltipClass="custom-tooltip"
                        matTooltip="Apply Filter">
                        <i class="fa fa-search" style="color: #fff"></i>
                    </button>
                    <button mat-mini-fab color="accent" class="fab-button" matTooltipClass="custom-tooltip"
                        matTooltip="History View" (click)="openPopupSafetyPyramidDetail($event,'history')">
                        <i class="fa fa-history" style="color: #fff"></i>
                    </button>
                    <button mat-mini-fab color="accent" class="fab-button" matTooltipClass="custom-tooltip"
                        matTooltip="Add" (click)="openPopupSafetyPyramidDetail($event,'add')">
                        <i class="fa fa-plus" style="color: #fff"></i>
                    </button>
                </div>
            </div>
            <div class="chart-group">
                <div class="chart-items">
                    <div class="chart-title">

                    </div>
                    <div style="min-width: 600px; max-width: 700px; margin: 0 auto" [chart]="chartPyramid"></div>
                </div>
                <div class="chart-items">
                    <div class="chart-title">
                    </div>
                    <div>
                        <tr>
                            <td>
                                <div><button class="m-top-btn" mat-raised-button>{{langObj ? langObj?.LastTimeInjury :
                                        ('LastTimeInjury' | translate)}}</button></div>
                                <div><button class="m-top-btn" mat-raised-button>{{langObj ?
                                        langObj?.MedicalTreatmentCase : ('MedicalTreatmentCase' | translate)}}</button>
                                </div>
                                <div><button class="m-top-btn" mat-raised-button>{{langObj ? langObj?.FirstAid :
                                        ('FirstAid' | translate)}}</button></div>
                                <div><button class="m-top-btn" mat-raised-button>{{langObj ? langObj?.FireIncident :
                                        ('FireIncident' | translate)}}</button></div>
                                <div><button class="m-top-btn" mat-raised-button>{{langObj ? langObj?.NearMiss :
                                        ('NearMiss' | translate)}}</button></div>
                                <div><button class="m-top-btn" mat-raised-button>{{langObj ?
                                        langObj?.UnsafeSituationHazard : ('Unsafe Situation[Hazard]' |
                                        translate)}}</button></div>
                            </td>
                            <td>
                                <div>
                                    <mat-card class="m-top-card"
                                        style="text-align: center; background-color: lightsalmon">
                                        <mat-card-title style="color: white; font-weight: bold; font-size: 18px;">
                                            {{langObj ? langObj?.TRIRYTD : ('TRIRYTD' | translate)}}
                                        </mat-card-title>
                                        <mat-card-content style="margin: 10px;">
                                            <span style="font-weight: bold; float: left; color: blue;">0.00</span>
                                            <span style="font-weight: bold; float: right; color: blue;">0.12</span><br>
                                            <span style="font-weight: bold; float: left; color: white;"> {{langObj ?
                                                langObj?.YTD : ('YTD' | translate)}}</span>
                                            <span style="font-weight: bold; float: right; color: white;"> {{langObj ?
                                                langObj?.Target : ('Target' | translate)}}</span>
                                        </mat-card-content>
                                    </mat-card>
                                </div>
                                <div>
                                    <mat-card class="m-top-card"
                                        style="text-align: center; background-color: lightsalmon">
                                        <mat-card-title style="color: white; font-weight: bold; font-size: 18px;">
                                            {{langObj ? langObj?.WORKINGMANHOURS : ('WORKINGMANHOURS' | translate)}}
                                        </mat-card-title>
                                        <mat-card-content style="margin: 10px;">
                                            <span style="font-weight: bold; float: center; color: blue;">946,028
                                                HOURS</span><br>
                                            <span style="font-weight: bold; float: center; color: white;">{{langObj ?
                                                langObj?.WITHOUTRECORDABLECASES : ('WITHOUTRECORDABLECASES' |
                                                translate)}}</span>
                                        </mat-card-content>
                                    </mat-card>
                                </div>
                                <div>
                                    <mat-card class="m-top-card"
                                        style="text-align: center; background-color: lightsalmon">
                                        <mat-card-title style="color: white; font-weight: bold; font-size: 18px;">
                                            {{langObj ? langObj?.THEBESTRECORDEDMANHOURS : ('THEBESTRECORDEDMANHOURS' |
                                            translate)}}
                                        </mat-card-title>
                                        <mat-card-content style="margin: 10px;">
                                            <span style="font-weight: bold; float: center; color: blue;">3,033,721
                                                {{langObj ? langObj?.HOURS : ('HOURS' | translate)}}</span><br>
                                            <span style="font-weight: bold; float: center; color: white;">{{langObj ?
                                                langObj?.DOYOURPARTTOHELPMAKEANEWRECORD :
                                                ('DOYOURPARTTOHELPMAKEANEWRECORD' | translate)}}</span>
                                        </mat-card-content>
                                    </mat-card>
                                </div>
                            </td>
                        </tr>
                    </div>
                </div>

            </div>
        </form>
    </div>
    <ng-template #safetyPyramidModal>
        <div>
            <div mat-dialog-title>
                <div class="d-flex justify-content-between align-items-center">
                    <h2>{{langObj ? langObj?.SafetyPyramidDetails : ('SafetyPyramidDetails' | translate)}}</h2>
                    <button mat-mini-fab mat-button mat-dialog-close color="warn" title="close">
                        <i class="fa fa-times" style="color: #fff"></i>
                    </button>
                </div>
            </div>
            <form [formGroup]="SafetyPyramidDetailForm" (ngSubmit)="saveSafetyDetail()" *ngIf="!history">
                <div class="form-group" class="content-top-row content-top-row-order-processing">
                    <mat-form-field appearence="fill"
                        class="top-row-first-filed-item top-row-first-filed-item-order-processing" style="width: 30%;">
                        <mat-label>{{langObj ? langObj?.TRIRYTD : ('TRIRYTD' | translate)}}</mat-label>
                        <input matInput type="text" formControlName="trirytd" />
                    </mat-form-field>

                    <mat-form-field appearence="fill"
                        class="top-row-first-filed-item top-row-first-filed-item-order-processing" style="width: 30%;">
                        <mat-label>{{langObj ? langObj?.TRIRTarget : ('TRIRTarget' | translate)}}</mat-label>
                        <input matInput type="text" formControlName="trirtarget" />
                    </mat-form-field>
                </div>
                <div class="content-top-row content-top-row-order-processing">
                    <mat-form-field appearence="fill"
                        class="top-row-first-filed-item top-row-first-filed-item-order-processing" style="width: 30%;">
                        <mat-label>{{langObj ? langObj?.WorkingManHour : ('WorkingManHour' | translate)}}</mat-label>
                        <input matInput type="text" formControlName="workingmanhour" />
                    </mat-form-field>

                    <mat-form-field appearence="fill"
                        class="top-row-first-filed-item top-row-first-filed-item-order-processing" style="width: 30%;">
                        <mat-label>{{langObj ? langObj?.TheBestrecordedmanhours : ('TheBestrecordedmanhours' |
                            translate)}}</mat-label>
                        <input matInput type="text" formControlName="bestrecordman" />
                    </mat-form-field>
                </div>
                <div>
                    <button mat-flat-button color="accent" class="btn-accent" style="margin-left: 25px;">{{langObj ?
                        langObj?.THEBESTRECORDEDMANHOUR : ('THEBESTRECORDEDMANHOUR' | translate)}}</button>
                </div>
                <!-- History grid -->


            </form>
            <mat-card-content *ngIf="history">
                <ag-grid-angular style="width: 100%; height: 24vw;" class="ag-theme-alpine" [rowData]="rowData"
                    [columnDefs]="columnDefs" (gridReady)="onGridReady($event)" [gridOptions]="gridOptions"
                    [pagination]="true" [paginationPageSize]="10">
                </ag-grid-angular>
            </mat-card-content>
        </div>

    </ng-template>
    <ng-template #safetyPyramidAddFatalAccident>
        <div class="viewChecklist">
            <div mat-dialog-title>
                <div class="d-flex justify-content-between align-items-center">
                    <h2>{{langObj ? langObj?.AddFatalAccident : ('AddFatalAccident' | translate)}}</h2>
                    <button mat-mini-fab mat-button mat-dialog-close color="warn" title="close">
                        <i class="fa fa-times" style="color: #fff"></i>
                    </button>
                </div>
            </div>
            <form [formGroup]="AddFatalAccidentForm">
                <div class="content-top-row content-top-row-order-processing">
                    <mat-form-field appearence="fill"
                        class="top-row-first-filed-item top-row-first-filed-item-order-processing" style="width: 30%;">
                        <input matInput formControlName="department"
                            placeholder="{{langObj ? langObj?.Department : ('Department' | translate)}}">
                    </mat-form-field>
                    <div class="inputField">
                        <nz-date-picker class="calender-input" id="startPicker" formControlName="eventDate"
                            nzFormat="dd-MMM-yyyy HH:mm:ss" style="width: 100%;" [nzShowTime]="{ nzFormat: 'HH:mm:ss' }"
                            required></nz-date-picker>
                        <span class="floating-text">{{langObj ? langObj?.EventDate : ('EventDate' | translate)}}</span>
                    </div>
                </div>
                <div class="content-top-row content-top-row-order-processing">
                    <mat-form-field appearence="fill"
                        class="top-row-first-filed-item top-row-first-filed-item-order-processing"
                        style="width: 100%; height: fit-content;">
                        <textarea matInput formControlName="description" rows="5"
                            placeholder="{{langObj ? langObj?.Description : ('Description' | translate)}}"></textarea>
                    </mat-form-field>
                </div>
                <div>
                    <button mat-flat-button color="accent" class="btn-accent"
                        style="float: right; margin-top: 50px;">{{langObj ? langObj?.Add : ('Add' |
                        translate)}}</button>
                </div>
            </form>
        </div>
    </ng-template>
</div>